import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { colors, withConstantPermissions } from 'shared'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { getAccounts, getAccountsLoading } from '../selectors'
import { translate, translateSelector, translateLKMessage } from '../helpers'
import { SELECTOR_NAME, INSTANCE_NAME, formName, objectName } from '../constants'
import { searchAgainAccounts } from '../actions'
import AccountForm, { open as openAccountForm } from '../../AccountForm'
import { withOpenedPages } from '../../OpenedPages'
import { accountDelete, getAccountSearchData, isAccountSearchLoading } from 'src/store/account'
import { bindActionCreators } from 'redux'
import { MomentInput } from 'moment'
import { AccSearchGridProps, AccountData } from './components.type'
import { AppDispatch } from 'src/store/index.d'
import { AccountAddParams } from '@lk/api'
import { RootState } from 'src/store/root.reducer'

const DLConfig = {
  columnConfigs: {
    OpenDate: {
      comparator: (a: MomentInput, b: MomentInput) => LKDate.compareSameFormat(a, b, 'YYYY-MM-DD HH:mm:ss'),
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    CloseDate: {
      comparator: (a: MomentInput, b: MomentInput) => LKDate.compareSameFormat(a, b, 'YYYY-MM-DD HH:mm:ss'),
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    AccActive: {
      iconComponent: (value: number) => {
        switch (value) {
          case 1: {
            return 'ok'
          }
          case 0: {
            return 'inactive'
          }
          default: {
            return null
          }
        }
      },
    },
    ID: {
      cellStyle: { textAlign: 'right' },
    },
    BalCodeID: {
      valueFormatter: ({ value }: { value: string }) =>
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
      cellStyle: { textAlign: 'right' },
    },
  },

  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: true,
  syncGridState: true,
  enableRowSelection: true,
  enableSorting: true,

  getRowNodeId: (row) => row?.ID,
  gridIdentity: {
    formName,
    objectName,
  },

  getRowStyle: ({
    node: {
      data: { AccActive },
    },
  }) => {
    if (AccActive === 0) {
      return { backgroundColor: colors.grey }
    }
    return {}
  },
}

const ACCOUNT_EDIT_MODAL = 'ACCOUNT_EDIT_MODAL'

//@ts-ignore
@withOpenedPages
@withRouter
//@ts-ignore
@withConstantPermissions([
  'ACC_ACCOUNT_OPEN as CanAdd',
  'ACC_ACCOUNT_EDIT as CanEdit',
  'ACC_ACCOUNT_DELETE as CanDelete',
])
//@ts-ignore
@connect(
  (state: RootState, { selector }: AccSearchGridProps) => ({
    // accounts: getAccounts(state, selector),
    // accountsLoading: getAccountsLoading(state, selector),
    accounts: getAccountSearchData(state, selector),
    accountsLoading: isAccountSearchLoading(state, selector),
  }),
  (dispatch: AppDispatch) => ({
    accountDelete: (params: Partial<AccountAddParams>) => dispatch(accountDelete(params)),
    openAccountForm: (ID: number, hash: string, copy: boolean) =>
      dispatch(openAccountForm(ACCOUNT_EDIT_MODAL, { ID, hash, copy, modalType: copy ? 'add' : 'edit' })),
    searchAgainAccounts: () => dispatch(searchAgainAccounts()),
    openError: (message: string, code?: string) => dispatch(LKModalActions.openError(message, code)),
  }),
)
class AccSearchGrid extends React.Component<AccSearchGridProps> {
  pushDetailsRoute = ({ ID, HashSum_AccountID_ }: AccountData) => {
    this.props.history.push(`/secure/account/${ID}/details/${HashSum_AccountID_}`)
  }

  pushStatementRoute = ({ ID, HashSum_AccountID_ }: AccountData) => {
    this.props.history.push(`/secure/account/${ID}/statement/${HashSum_AccountID_}`)
  }

  onRowDoubleClicked = ({ node: { data } }: { node: { data: AccountData } }) => {
    if (this.props.selector) {
      this.props.onSelect(data)
    } else {
      this.pushDetailsRoute(data)
    }
  }

  getContextMenuItems = (params: { node: { data: AccountData } }) => {
    const {
      node: { data },
    } = params

    return [
      {
        type: 'title',
        name: data.TitleUNI,
      },

      ...(this.props.selector
        ? [
            {
              name: translateSelector('cmd_finish'),
              action: () => this.props.onSelect(data),
              icon: 'hand',
            },
          ]
        : [
            {
              name: translate('cmd_view'),
              action: () => this.pushDetailsRoute(data),
              icon: 'info',
              permissionKey: 'ACC_ACCOUNT_OPEN',
            },

            {
              name: translate('cmd_statement'),
              action: () => this.pushStatementRoute(data),
              icon: 'transactions',
              permissionKey: 'ACC_STATEMENT_VIEW',
            },
            this.props.CanAdd
              ? {
                  name: translate('cmd_copy_account'),
                  icon: 'copy',
                  action: () => this.props.openAccountForm(data.ID, data.HashSum_AccountID_, true),
                  disabled: !this.props.CanAdd,
                }
              : undefined,

            this.props.CanEdit
              ? {
                  name: translate('cmd_edit'),
                  icon: 'edit',
                  action: () => this.props.openAccountForm(data.ID, data.HashSum_AccountID_, false),
                  disabled: !this.props.CanEdit,
                  permissionKey: 'ACC_ACCOUNT_EDIT',
                }
              : undefined,

            this.props.CanDelete
              ? {
                  name: translate('cmd_delete'),
                  icon: 'delete',
                  disabled: !this.props.CanDelete,
                  action: () => this.deleteAccount({ ID: data.ID, hash: data.HashSum_AccountID_ }),
                  confirmModalConfig: { message: translateLKMessage('MSG_ARE_YOU_SURE') },
                  permissionKey: 'ACC_ACCOUNT_DELETE',
                }
              : undefined,
            'excelExport',
          ].filter((x) => x !== undefined)),
    ]
  }

  deleteAccount = async ({ ID, hash }: { ID: number; hash: string }) => {
    try {
      const accountDeleteResult = await this.props.accountDelete({
        AccountID: ID,
        HashSum_AccountID_: hash,
      })
      if (accountDelete.fulfilled.match(accountDeleteResult)) {
        this.props.openedPages.onRemoveWindowIfExists(`/secure/account/${ID}/details/${hash}`)
        this.props.searchAgainAccounts()
      } else {
        throw accountDeleteResult.payload
      }
    } catch (err) {
      console.log(err)
      this.props.openError(translateLKMessage(err), err)
    }
  }

  render() {
    const { accounts, accountsLoading, selector } = this.props

    if (!accounts) {
      return null
    }

    return (
      <>
        {!selector && <AccountForm name={ACCOUNT_EDIT_MODAL} />}
        <LKGrid
          instanceName={selector ? SELECTOR_NAME : INSTANCE_NAME}
          {...DLConfig}
          onRowDoubleClicked={this.onRowDoubleClicked}
          getContextMenuItems={this.getContextMenuItems}
          rowData={this.props.accounts}
          loading={accountsLoading}
        />
      </>
    )
  }
}

export default AccSearchGrid
